<ds-error-message [errorList]="errorList"></ds-error-message>
@if ((vehicleCoveragesFacade.coverages$ | async)?.length > 0) {
  <form [formGroup]="updateCoverageForm">
    <div class="wrapper row pad-horizontal-10">
      <div class="column twelve md-nine">
        <div
          class="pad-top-20 margin-bottom-20 pad-horizontal-10 row column twelve lg-push-two md-ten md-push-two"
        >
          <h5 dsContent class="bold-header" [contentPath]="'policy.changeCoverage.step1of2'"></h5>
          <h2
            dsContent
            [contentPath]="'policy.changeCoverage.updateCoverageHeader'"
            class="bold-header"
          ></h2>
          <div class="pad-bottom-60"></div>
          @if (isPartner) {
            <div class="margin-bottom-40">
              <ds-coverages-info
                [isPartner]="true"
                [state]="stateCode$ | async"
                [selectedId]="vehicleCoveragesFacade.selectedId$ | async"
                [vehicleDesc]="vehicleCoveragesFacade.vehicleName$ | async"
                [form]="updateCoverageForm"
                [coverages]="coverages$ | async"
                (updateCoverage)="updateCoverage($event)"
                [isRecalculate]="isRecalculate"
              ></ds-coverages-info>
            </div>
          }
          @if (!isPartner) {
            <div class="margin-bottom-40">
              <ds-coverages-info
                [isPartner]="false"
                [state]="stateCode$ | async"
                [selectedId]="vehicleCoveragesFacade.selectedId$ | async"
                [vehicleDesc]="vehicleCoveragesFacade.vehicleName$ | async"
                [form]="updateCoverageForm"
                [coverages]="afiCoverages$ | async"
                (updateCoverage)="updateCoverage($event)"
                [isRecalculate]="isRecalculate"
              ></ds-coverages-info>
            </div>
          }
        </div>
        <div class="row column twelve lg-push-two md-ten md-push-two margin-bottom-20">
          <blockquote class="border -primary-800 caption">
            <div
              dsContent
              [contentPath]="'policy.changeCoverage.updateCoverageDisclaimer1'"
              class="margin-bottom-10"
            ></div>
          </blockquote>
        </div>
        <div
          class="pad-top-20 pad-horizontal-10 row column twelve lg-push-two md-ten md-push-two call-to-action-button"
        >
          <call-to-action
            [displayBackButton]="true"
            [tertiaryButtonName]="'Cancel'"
            [primaryButtonName]="'Continue'"
            (primaryEvent)="nextStep()"
            (tertiaryEvent)="cancel()"
            (backEvent)="goBackOneStep()"
            [disablePrimaryButton]="isRecalculate === false"
            [capitalize]="!isPartner"
          ></call-to-action>
        </div>
      </div>
      @if (vehicleCoveragesFacade.rate$ | async) {
        <div class="sidebar column twelve md-three">
          <ds-recalculate-sidebar
            [vehicleName]="vehicleCoveragesFacade.vehicleName$ | async"
            (recalculateQuote)="recalculate($event)"
            [vehicleCurrentRate]="vehicleCoveragesFacade.rate$ | async"
            [canRecalculate]="vehicleCoveragesFacade.canRecalculate$ | async"
            (resetQuote)="onResetQuote()"
            [isPartner]="isPartner"
            [enableResetCoverage]="
              (vehicleCoveragesFacade.ids$ | async)?.length > initialCoverageFacadeIdLength &&
              (vehicleCoveragesFacade.canRecalculate$ | async) === false
            "
          ></ds-recalculate-sidebar>
        </div>
      }
    </div>
  </form>
}
